import { EnvironmentProviders, Provider, inject } from "@angular/core";
import { provideApollo } from "apollo-angular";
import { HttpBatchLink } from "apollo-angular/http";
import { InMemoryCache } from "@apollo/client/core";
import { GraphService } from "./services/graph.service";
import { QueryConstructorService } from "./services/query-constructor.service";

/**
 * Provides GraphQL configuration for standalone components
 * @param uri GraphQL endpoint URI
 */
export function provideGraphQL(uri: string): (Provider | EnvironmentProviders)[] {
  return [
    GraphService,
    QueryConstructorService,
    provideApollo(() => {
      const httpLink = inject(HttpBatchLink);
      return {
        cache: new InMemoryCache({ addTypename: false }),
        // link: error.concat(httpLink.create({ uri, batchInterval: 20 })),
        link: httpLink.create({ uri, batchInterval: 20 }),
        defaultOptions: {
          watchQuery: { fetchPolicy: "no-cache", errorPolicy: "all" },
          query: { fetchPolicy: "no-cache", errorPolicy: "all" },
        },
      };
    }),
  ];
}
